// DashboardPage - Complete dashboard with analytics
import { Container, Title, Text, Stack, Grid, Button, Group } from '@mantine/core';
import { IconPlus, IconRefresh } from '@tabler/icons-react';
import { useAuth } from '@/hooks/useAuth';
import { useLeads, useDashboardAnalytics } from '@/hooks/useLeads';
import { DashboardStats } from '@/components/features/dashboard/DashboardStats/DashboardStats';
import { LeadsChart } from '@/components/features/dashboard/LeadsChart/LeadsChart';
import { SourcesChart } from '@/components/features/dashboard/SourcesChart/SourcesChart';
import { RecentLeads } from '@/components/features/dashboard/RecentLeads/RecentLeads';
import { Loading } from '@/components/common/Loading/Loading';

export const DashboardPage = () => {
  const { user } = useAuth();
  const { data: analytics, isLoading: analyticsLoading, refetch } = useDashboardAnalytics();
  const { data: leadsData, isLoading: leadsLoading } = useLeads({ limit: 10 });
  const leads = leadsData?.data || [];

  if (analyticsLoading && !analytics) {
    return <Loading message="Loading dashboard..." />;
  }

  return (
    <Container size="xl" py="xl">
      <Stack gap="lg">
        {/* Header */}
        <Group justify="space-between">
          <div>
            <Title order={1}>Welcome, {user?.name}!</Title>
            <Text c="dimmed" mt="sm">
              Your CarLeads dashboard - Real-time insights and analytics
            </Text>
          </div>
          <Group>
            <Button
              variant="light"
              leftSection={<IconRefresh size={16} />}
              onClick={() => refetch()}
            >
              Refresh
            </Button>
            <Button leftSection={<IconPlus size={16} />}>New Lead</Button>
          </Group>
        </Group>

        {/* KPI Stats */}
        {analytics && (
          <DashboardStats stats={analytics.stats} isLoading={analyticsLoading} />
        )}

        {/* Charts */}
        <Grid>
          <Grid.Col span={{ base: 12, md: 8 }}>
            {analytics && (
              <LeadsChart data={analytics.leadsOverTime} isLoading={analyticsLoading} />
            )}
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            {analytics && (
              <SourcesChart data={analytics.leadsBySource} isLoading={analyticsLoading} />
            )}
          </Grid.Col>
        </Grid>

        {/* Recent Leads Table */}
        <RecentLeads leads={leads || []} isLoading={leadsLoading} />
      </Stack>
    </Container>
  );
};
